// --- AI Pipeline Types ---
// ── Node Types ──
export const CORE_PIPELINE_NODE_TYPES = [
    'manualTrigger',
    'cronTrigger',
    'eventTrigger',
    'webhookTrigger',
    'aiPrompt',
    'aiDecision',
    'agentCall',
    'toolCall',
    'condition',
    'loop',
    'errorHandler',
    'transform',
    'notify',
    'webhookOutput',
    'atlasSearch',
    'zodValidation',
    'hitlApproval',
    'subPipeline',
    // E3 CRM party model (roadmap #457, PR-4/6) — registered CRM action nodes. The FIRST
    // proof of the "registered artifact" extension model: a lead-conversion pipeline reuses
    // these to dedup an inbound capture against existing parties and (on approval) materialise
    // a person + party_role through the SAME PEP the platform's other writers pass through.
    'entityDedup',
    'entityCreateWithRole',
];
/** The shape of an extension-declared node type (and of an extension's web node kind key). */
export const PIPELINE_NODE_TYPE_NAME = /^[a-z][a-zA-Z0-9]*$/;
export function isCorePipelineNodeType(type) {
    return CORE_PIPELINE_NODE_TYPES.includes(type);
}
export const PIPELINE_NODE_CATEGORIES = {
    trigger: ['manualTrigger', 'cronTrigger', 'eventTrigger', 'webhookTrigger'],
    ai: ['aiPrompt', 'aiDecision', 'agentCall'],
    action: [
        'toolCall',
        'transform',
        'entityDedup',
        'entityCreateWithRole',
    ],
    flow: ['condition', 'loop', 'errorHandler'],
    output: ['notify', 'webhookOutput'],
    atlas: ['atlasSearch'],
    validation: ['zodValidation'],
    hitl: ['hitlApproval'],
    composition: ['subPipeline'],
};
//# sourceMappingURL=pipeline.types.js.map